import { Button, Col, Form, message, Row, Select } from 'antd';
import Modal from 'antd/lib/modal/Modal';
import { FC, useState } from 'react';
import FormItem from "antd/es/form/FormItem";
import { Box } from "@mui/material";
import { ArrowLeftOutlined, ArrowRightOutlined, GiftFilled } from '@ant-design/icons';
import { Ticket } from "../Raffles/interfaces";
import { getGenericCollection } from "../../services/firestore";
import { limit, orderBy, startAt, where } from "firebase/firestore";
import useIsSmallScreen from "../../hooks/useIsSmallScreen";

interface PropsHomeModalInfo {
  open: boolean;
  onClose: () => void;
  raffleId: string;
  countTicketsRaffle: number;
  onReserveTickets: (tickets: Ticket[]) => void;
}

const LuckyMachineModal: FC<PropsHomeModalInfo> = ({ open, onClose, raffleId, countTicketsRaffle, onReserveTickets }) => {
  const [quantityTickets, setQuantityTickets] = useState<number | undefined>(undefined);
  const [working, setWorking] = useState(false);
  const [tickets, setTickets] = useState<Ticket[]>([]);
  const isSmallScreen = useIsSmallScreen();

  const generateRandomNumbers = (quantityTickets: number) => {
    const numbers: number[] = [];

    while (numbers.length < quantityTickets) {
      const randomNum = Math.floor(Math.random() * countTicketsRaffle) + 1;

      if (!numbers.includes(randomNum)) {
        numbers.push(randomNum);
      }
    }

    return numbers;
  };

  const searchTickets = async () => {
    if (!quantityTickets || working) return;

    setWorking(true);
    setTickets([]);

    const _tickets: Ticket[] = [];
    let lastSize = 0;

    try {
      //falta vlaidacion maximo de intentos
      while (_tickets.length < quantityTickets) {
        const numbers = generateRandomNumbers(quantityTickets);

        let randomTickets = (await Promise.all(
          numbers.map(n =>
            getGenericCollection<Ticket>(
              "tickets",
              [
                where("raffleId", "==", raffleId),
                where("status", "==", "Libre"),
                orderBy("number", "asc"),
                startAt(n),
                limit(1)
              ]
            )
          )
        )).flat();

        for (const rt of randomTickets) {
          if (_tickets.some(t => t.id === rt.id)) continue;
          _tickets.push(rt);
        }

        if (!randomTickets.length || _tickets.length < quantityTickets) {
          randomTickets = (await Promise.all(
            numbers.map(n =>
              getGenericCollection<Ticket>(
                "tickets",
                [
                  where("raffleId", "==", raffleId),
                  where("status", "==", "Libre"),
                  orderBy("number", "desc"),
                  startAt(n),
                  limit(1)
                ]
              )
            )
          )).flat();

          for (const rt of randomTickets) {
            if (_tickets.some(t => t.id === rt.id)) continue;
            _tickets.push(rt);
          }
        }

        if (_tickets.length === lastSize) break;
        lastSize = _tickets.length;
      }

      setTickets(_tickets);
    } catch (error) {
      console.error("Error al generar los boletos:", error);
      message.error("Error al generar los boletos, intente nuevamente.", 5);
    } finally {
      setWorking(false);
    }
  };

  return (
    <Modal
      open={open}
      cancelButtonProps={{
        hidden: true
      }}
      onOk={() => onClose()}
      okButtonProps={{
        hidden: true
      }}
      onCancel={() => onClose()}
      maskClosable={false}
    >
      <div
        style={{
          marginTop: 20,
          fontWeight: "bold",
          fontSize: 18,
          textAlign: "center",
          backgroundColor: "orangered",
          color: "white",
          borderRadius: 10,
          padding: 10
        }}
      >
        MÁQUINA DE LA SUERTE
      </div>
      <br />
      <Form layout="vertical">
        <FormItem
          label={
            <label
              style={{
                fontWeight: "bold",
                fontSize: 16
              }}
            >
              Cantidad de boletos para la máquina de la suerte
            </label>
          }
        >
          <Select
            placeholder="Seleccione la cantidad de boletos"
            value={quantityTickets}
            onChange={(value) => setQuantityTickets(value)}
            size="large"
          >
            <Select.Option key={1} value={1}>1 boleto</Select.Option>
            <Select.Option key={5} value={5}>5 boletos</Select.Option>
            <Select.Option key={10} value={10}>10 boletos</Select.Option>
            <Select.Option key={15} value={15}>15 boletos</Select.Option>
            <Select.Option key={20} value={20}>20 boletos</Select.Option>
            <Select.Option key={30} value={30}>30 boletos</Select.Option>
            <Select.Option key={40} value={40}>40 boletos</Select.Option>
            <Select.Option key={50} value={50}>50 boletos</Select.Option>
            <Select.Option key={100} value={100}>100 boletos</Select.Option>
          </Select>
        </FormItem>
        <Box
          display="flex"
          justifyContent="center"
          marginTop={4}
        >
          <Button
            type="primary"
            size="large"
            disabled={!quantityTickets}
            onClick={() => searchTickets()}
            style={{
              backgroundColor: "green",
              fontWeight: "bold",
              fontSize: 16,
            }}
            loading={working}
          >
            <GiftFilled />
            GENERAR BOLETOS
            <GiftFilled />
          </Button>
        </Box>
      </Form>
      <br />
      {
        Boolean(tickets.length) && <Box
          display="flex"
          justifyContent="center"
        >
          <Button
            size="large"
            style={{
              color: "white",
              backgroundColor: "orangered",
              fontWeight: "bold",
            }}
            onClick={() => {
              onReserveTickets(tickets);
              onClose();
            }}
          >
            <ArrowRightOutlined />
            APARTAR BOLETOS
            <ArrowLeftOutlined />
          </Button>
        </Box>
      }
      <br />
      <Row
        justify="center"
      >
        {
          tickets.map((ticket: Ticket) => (
            <Col xs={4} key={ticket.id} style={{ padding: 2 }}>
              <div
                style={{
                  height: 35,
                  cursor: "pointer",
                  backgroundColor: ticket.status === "Libre" ? "green" : "red",
                  borderRadius: 20,
                  color: "white",
                  fontSize: isSmallScreen ? 12 : 16,
                  textAlign: "center",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center"
                }}
              >
                <div>
                  {ticket.number.toString().padStart(6, "0")}
                </div>
              </div>
            </Col>
          ))
        }
      </Row>
    </Modal >
  );
};

export default LuckyMachineModal;
